// extracted by mini-css-extract-plugin
export default {"shell":"enter-code_shell__pSo9E","header":"enter-code_header__7mjfM","logo":"enter-code_logo__LWfGK","logoutBtn":"enter-code_logoutBtn__8Z7J6","main":"enter-code_main__g+8nS"};